import { Columns } from '@zmedia/bm-soccer-ui/components';
import { memo } from 'react';
import { SECTION_ID } from '@zmedia/bm-soccer-ui/constants';
import { ContentMoreSection } from '@zmedia/bm-soccer-ui/modules/content';
import { TournamentSection } from '@zmedia/bm-soccer-ui/modules/tournament';
import { renderSections } from '@zmedia/bm-soccer-ui/modules/shared/components/sections';
import styles from './style.module.scss';

const SECTION_MAP = {
    [SECTION_ID.CONTENT_LOAD_MORE]: ContentMoreSection,
};

const SECTION_MAP_SIDEBAR = {
    [SECTION_ID.TOURNAMENT]: TournamentSection,
};

export function GridHome(props: any) {
    const { data, listProps } = props;
    return (
        <Columns className={styles['columns-home']}>
            {data?.sections && (
                <Columns.Column type="main">
                    {renderSections(
                        data.sections.slice(-1),
                        SECTION_MAP,
                        listProps
                    )}
                </Columns.Column>
            )}

            {data.sidebar && (
                <Columns.Column type="sub">
                    {renderSections(
                        data.sidebar?.sections,
                        SECTION_MAP_SIDEBAR,
                        listProps
                    )}
                </Columns.Column>
            )}
        </Columns>
    );
}

export default memo(GridHome);
